<div *ngrxLet="customFacade.customReuseError$ as error" class="modal-content" piqetAngularDraggable>
  <div *ngrxLet="customFacade.reuseIngredientList$ as reuseIngredientList">
    <div class="modal-header">
      <h2 class="modal-title ml-auto pl-5" id="exampleModalLabel">
        <div class="bootstrap-dialog-title" id="dialogMaterialCreate_title">{{ modalLabel }}</div>
      </h2>

      <button type="button" class="closeModal pull-right" aria-label="Close" (click)="onClose()">
        <img src="./assets/icons/pop-up-cross.svg" width="16" height="17" />
      </button>
    </div>
    <div class="modal-body body-modal">
      <form [formGroup]="customReuseForm" [ngClass]="{ 'disabled-popup': !checkEntireAccess }">
        <div class="field-validation-error"></div>
        <div class="row">
          <div
            class="col-sm-12"
            [ngStyle]="{ 'col-sm-12': isHideDropDown === true ? 'col-sm-6' : 'col-sm-12' }"
          >
            <div class="form-group required" aria-required="true">
              <piqet-angular-common-input
                formControlName="reuseName"
                [control]="customReuseForm.get('reuseName')"
                label="Reuse process name"
                placeholder="Reuse process name"
                [maxLength]="50"
                [submitted]="submitted"
              >
              </piqet-angular-common-input>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-6" *ngIf="isHideDropDown">
            <div class="form-group required">
              <ng-select
                [clearable]="true"
                [clearOnBackspace]="false"
                #material
                [items]="organizationlist"
                [searchable]="false"
                bindLabel="name"
                formControlName="organizationName"
                [searchFn]="commonInputSearch"
                [readonly]="isDisabledDropDown"
                placeholder="Organization"
                [(ngModel)]="setOrganizationValue"
                (change)="selectValue($event)"
              >
                <ng-template ng-header-tmp>
                  <div class="has-feedback">
                    <input
                      type="text"
                      (input)="material.filter($any($event.target).value)"
                      class="accordion-search form-control search-input"
                      id="inputValidation"
                      placeholder="Search..."
                    />
                    <span class="form-control-feedback">
                      <i class="fa fa-search icon"></i>
                    </span>
                  </div>
                </ng-template>
                <ng-template ng-option-tmp let-item="item" let-search="searchTerm">
                  <div [ngOptionHighlight]="search" title="{{ item?.name }}">{{ item.name }}</div>
                </ng-template>
              </ng-select>
              <div
                *ngIf="
                  (customReuseForm.controls['organizationName']?.touched &&
                    customReuseForm.controls['organizationName']?.invalid) ||
                  customReuseForm.controls['organizationName'].value?.name === 'Organization' ||
                  (submitted && !customReuseForm.controls['organizationName'].value?.name)
                "
                class="input-error"
              >
                Organization is required.
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="panel-body">
            <div class="portlet light" style="padding-bottom: 0; margin-bottom: 0; padding-left: 0">
              <div class="portlet-title">
                <div class="caption">
                  <span class="font-sharp">Add reuse process per reuse cycle</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div id="divmanufactureofmaterialList" class="grid-div cutomBtn-margin">
        <input
          data-val="true"
          data-val-number="The field CustomReuseId must be a number."
          data-val-required="The CustomReuseId field is required."
          type="hidden"
          value="0"
        />
        <ng-container>
          <piqet-angular-portlet
            [columnDefs]="processColumnDef"
            [frameworkComponents]="frameworkComponents"
            [gridData]="reuseIngredientList"
            [hidePagination]="true"
            [hideSearch]="true"
            [headerBtn]="headerBtn"
            [headerBtnName]="headerBtnName"
            [disableButton]="disableSubmit || isRowEditable"
            [showErrorInAccordian]="true"
            [error]="error"
            [isCheckOrgaizationReport]="true"
            [class]="'overflowCheck'"
            [inlineEdit]="true"
            (editDataEvent)="checkValidation(reuseIngredientList)"
            [createAccess]="checkEntireAccess"
            (inlineDataEditEvent)="inlineDataEditEvent($event)"
            [isInlineGrid]="true"
          >
          </piqet-angular-portlet>
        </ng-container>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="cancelBtn" (click)="onClose()">Cancel</button>
      <button
        type="button"
        class="modelBtn purpleBtnHoverEffect"
        [disabled]="disableSubmit || isRowEditable"
        *ngIf="checkEntireAccess"
        (click)="onSave(reuseIngredientList)"
      >
        Save
      </button>
    </div>
  </div>
</div>
